<div class="content-wrapper max-width-p mt-2">
  <div class="content-body">
    <p>
      {{ 'MOBILE_CARD_PAYMENT.PROCESSING' | translate }}
    </p>
  </div>
</div>
